const _formatLines = {
  id: (val) => `S${val} \n`,
  driverName: (val) => `${val} \n`,
  driverPhone: (val) => `${val} \n`,
  plates: (val) => {
    if (Array.isArray(val)) {
      return val.length > 1 ? `${val.join(' + ')} \n` : '';
    }
    return `${val} \n`;
  },
  pickups: (val) => {
    if (Array.isArray(val)) {
      return val.map((pickup) => `${pickup} \n`);
    }
    return `${val} \n`;
  },
};

export const formatData = (listOfJourneys) =>
  listOfJourneys
    .map(
      (journeyInfo) =>
        Object.entries(journeyInfo)
          .map(([key, value]) => (_formatLines[key] ? _formatLines[key](value) : ''))
          .join('') + '\n'
    )
    .join('');
